<template>
  <div
    class="iconHolder"
    :style="{
      'border-color' : circleColor,
      'color' : color
    }"
    :class="(size) ? `bm-${size}` : ''"
  >
    <span :class="'icon-' + name" v-if="!text && name"></span>
    <div class="iconHolder-text" v-if="text !== ''">{{text}}</div>
  </div>
</template>

<script>
export default {
  props: ['name', 'text', 'size', 'color', 'circleColor']
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('iconHolder')
  width: 30px
  height: 30px
  border-radius: 30px
  box-sizing: border-box
  border: 2px solid transparent
  display: flex
  justify-content: center
  align-items: center
  line-height: normal
  font-size: 20px

  +blockModifier('large')
    width: 40px
    height: 40px
    border-radius: 40px
    font-size: 22px

  +blockModifier('small')
    width: 24px
    height: 24px
    border-radius: 24px
    font-size: 18px

  +blockModifier('tiny')
    width: 18px
    height: 18px
    border-radius: 18px
    font-size: 10px

  +element('text')
    font-size: 14px

</style>



// WEBPACK FOOTER //
// src/globalComponents/Icon.vue